import './logo.css';

interface LogoProps {
  /** "mark" is the glyph alone (tight spaces); "full" is the Ederest wordmark. */
  variant?: 'mark' | 'full';
  /** Product name shown beside the wordmark. */
  suffix?: string;
}

export function Logo({ variant = 'full', suffix }: LogoProps) {
  if (variant === 'mark') {
    return <img className="logo__mark" src="/ederest-mark.svg" alt="Ederest" width={26} height={26} />;
  }

  return (
    <span className="logo">
      <img className="logo__wordmark" src="/ederest-wordmark.svg" alt="Ederest" />
      {suffix && <span className="logo__suffix">{suffix}</span>}
    </span>
  );
}
